// Import graphql_api directly, not features/recaps index: the barrel loads RecapsPage /
// NotetakerButton first, which import meeting_intelligence → hooks while this module is still
// loading (circular CJS/Jest).
import { useNotetakerEntitled } from 'features/meeting_intelligence'
import { useHasAnyRecapsQuery } from 'features/recaps/graphql_api'

import { useNotetakerMarketEligibility } from './useNotetakerMarketEligibility'

/**
 * Whether Core Notetaker UI (nav, settings shell, recap history) should be visible.
 * Entitlement and ever-having-a-recap permanently grant access; otherwise market eligibility applies.
 */
export const useNotetakerCoreUiVisible = ({ legacyVisible } = {}) => {
  const { isEntitled, isLoading: isEntitlementLoading } = useNotetakerEntitled()
  const {
    isEligible: marketEligible,
    isLoading: isMarketLoading,
    isGatingEnabled,
  } = useNotetakerMarketEligibility()

  const skipRecapsCheck = !isGatingEnabled
    || isEntitlementLoading
    || isMarketLoading
    || isEntitled
    || marketEligible
  const { data: recapsData, isLoading: isRecapsLoading } = useHasAnyRecapsQuery(undefined, { skip: skipRecapsCheck })

  if (!isGatingEnabled) {
    return { isVisible: legacyVisible ?? isEntitled, isLoading: false }
  }

  const hasAnyRecaps = (recapsData?.total ?? 0) > 0
  const isVisible = isEntitled || hasAnyRecaps || marketEligible
  const isLoading = !isVisible
    && (isEntitlementLoading || isMarketLoading || (!skipRecapsCheck && isRecapsLoading))

  return { isVisible, isLoading }
}
